import styled from '@emotion/styled';
import { FC, useMemo, useRef, useState } from 'react';

import { ResizeObserverDimensions, useResizeObserver } from 'app/components/v2/hooks';
import { PropsWithOnlyChildren } from 'app/types';

import { closedListWidth } from './SideNav';

const StyledMain = styled.main<{ width?: number }>(({ theme, width }) => ({
  flexGrow: 1,
  minHeight: '100%',
  overflowX: 'auto',
  right: 0,

  // eslint-disable-next-line sort-keys,@typescript-eslint/naming-convention
  '& > *': {
    width,
  },

  [theme.components.mediaQueries.sm.max]: {
    marginLeft: closedListWidth,
  },

  [theme.components.mediaQueries.xs.max]: {
    marginLeft: 0,
  },
}));

const Main: FC<PropsWithOnlyChildren> = ({ children }) => {
  const [dimensions, setDimensions] = useState<ResizeObserverDimensions>();

  const ref = useRef<HTMLElement>(null);

  const rectWidth = ref.current?.getBoundingClientRect().width;

  useResizeObserver(ref,
    setDimensions);

  return useMemo(() => (
    <StyledMain
      ref={ref}
      width={dimensions?.width ?? rectWidth}
    >
      {children}
    </StyledMain>
  ),
  [rectWidth, ref, children, dimensions?.width]);
};

export default Main;
